import React, { useState } from "react";
import { Drawer, Button } from "antd";

import { useSelector } from "react-redux";
import { CircularProgress } from "@mui/material";
import CustomTextField from "../../common/InputField/Input";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import { bookingDetailsDrawerWidth } from "../../../utils/bookingDetailsHelper";
import { IoIosArrowRoundBack } from "react-icons/io";
import GenderButton from "../../common/components/Booking/GenderButton";
import useAddPrimaryGuest from "../../../hooks/bookingCustomHook/UseAddPrimaryCustomer";
import DOB from "../../common/components/Booking/DOB";
import { updateDisplayDOB } from "../../../reducer/bookingReducer";
import UploadId from "../../common/components/UploadID";
import ArrivalAndDurationDate from "../components/ArrivalAndDurationDate";

const AddPrimaryGuestDrawer = () => {
  const { showPrimaryGuestDrawer, displayDOB, displayDate } = useSelector(
    (store) => store.booking
  );

  const [customerData, setCustomerData] = useState({});
  const [fetchedName, setFetchedName] = useState("");

  const [selectedTab, setSelectedTab] = useState("Primary Details");

  const [loading, setLoading] = useState(false);
  const [customerDataLoading, setCustomerDataLoading] = useState(false);

  const {
    handleClose,
    handleCustomerDataFieldChange,
    handleDateState,
    handleSave,
  } = useAddPrimaryGuest(
    customerData,
    setCustomerData,
    setCustomerDataLoading,
    setLoading,
    displayDate,
    displayDOB,
    setFetchedName,
    fetchedName
  );

  return (
    <Drawer
      headerStyle={{ padding: 0 }}
      title={
        <div className="bg-[#F9FBFC] p-2 pl-4 border-b-[1px] border-[#F2F4FC] flex items-center gap-3 ">
          <IoIosArrowRoundBack
            className="text-[24px] cursor-pointer text-[#292D32]"
            onClick={handleClose}
          />
          <span className="font-outfit font-[500] text-[18px] leading-[27px] text-[#222222]">
            {showPrimaryGuestDrawer?.customerType === "existing"
              ? "Edit"
              : "Add"}{" "}
            Primary Guest
          </span>
        </div>
      }
      closable={false}
      onClose={() => handleClose()}
      open={showPrimaryGuestDrawer.visible}
      width={bookingDetailsDrawerWidth}
    >
      <div onClick={handleDateState} className="h-[100%] w-[100%]">
        {customerDataLoading ? (
          <div className="w-full h-screen flex justify-center items-center">
            <CircularProgress size={32} />
          </div>
        ) : (
          <div className="relative pl-3 h-full">
            <Tab selectedTab={selectedTab} setSelectedTab={setSelectedTab} />

            <main className="mt-[20px]">
              {selectedTab === "Foreign Details" && (
                <ForeignDetails
                  customerData={customerData}
                  handleCustomerDataFieldChange={handleCustomerDataFieldChange}
                />
              )}
              {selectedTab === "Company Details" && (
                <CompanyDetails
                  customerData={customerData}
                  handleCustomerDataFieldChange={handleCustomerDataFieldChange}
                />
              )}
              {selectedTab === "Primary Details" && (
                <PrimaryDetails
                  customerData={customerData}
                  handleCustomerDataFieldChange={handleCustomerDataFieldChange}
                  displayDOB={displayDOB}
                />
              )}
            </main>

            <Footer
              customerData={customerData}
              loading={loading}
              handleSave={handleSave}
            />
          </div>
        )}
      </div>
    </Drawer>
  );
};

const Tab = ({ selectedTab, setSelectedTab }) => {
  const handleTab = (value) => {
    setSelectedTab(value);
  };

  return (
    <div className=" w-[100%] flex justify-between items-center">
      {["Primary Details", "Company Details", "Foreign Details"]?.map((Obj) => {
        return (
          <div
            value={Obj}
            onClick={() => handleTab(Obj)}
            className={` ${
              selectedTab === Obj
                ? "text-[#007FFF]  border-b-[#007FFF] "
                : "text-[#667085]  border-b-[#FFF]"
            } font-[500] text-[12px] uppercase cursor-pointer text-center tracking-[1%] border-b-[2px] flex-1 h-[44px]`}
          >
            {Obj}
          </div>
        );
      })}
    </div>
  );
};

const PrimaryDetails = ({
  customerData,
  displayDOB,
  handleCustomerDataFieldChange,
}) => {
  const handlePhoneChange = (value, country) => {
    const parts = country.inputValue.split(" ");
    let countryCode = parts?.[0];
    const joinedString = parts
      ?.slice(1)
      ?.map((str) => str?.replace(/\D/g, "")) // Remove non-numeric characters
      ?.join("");

    handleCustomerDataFieldChange("contactDetails", {
      ...customerData?.contactDetails,
      countryCode: countryCode,
      phoneNumber: joinedString,
      phoneValue: value,
    });
  };

  return (
    <div className="mt-3 px-4 flex flex-col gap-[16px] pb-[32px] relative no-scrollbar">
      <div className="flex justify-between items-center gap-[24px]">
        <div className="flex flex-col gap-[6px] no-scrollbar w-[50%]">
          <div className="text-[#222B45] text-[14px]">Contact Number</div>
          <div className="relative">
            <PhoneInput
              value={customerData?.contactDetails?.phoneValue ?? ""}
              onChange={handlePhoneChange}
              defaultCountry="in"
              required={true}
              forceDialCode={true}
            />
          </div>
        </div>

        <div className="flex flex-col gap-[6px] w-[50%]">
          <div className="text-[#222B45] text-[14px]">Guest Name</div>
          <CustomTextField
            label=""
            value={customerData?.name}
            onChange={(value) => handleCustomerDataFieldChange("name", value)}
            isMandatory={true}
            type="text"
            inputPadding={true}
            inputPaddingValue="2px"
            borderColor="#DCE2ED"
            borderWidth="1px"
          />
        </div>
      </div>

      <div className="flex justify-between items-center gap-[24px]">
        <div className="flex flex-col gap-[6px] w-[55%]">
          <div className="text-[#222B45] text-[14px]">Email Id</div>
          <CustomTextField
            label=""
            value={customerData?.email}
            onChange={(value) => handleCustomerDataFieldChange("email", value)}
            isMandatory={false}
            type="email"
            inputPadding={true}
            inputPaddingValue="2px"
            borderColor="#EDF1F7"
            borderWidth="1px"
          />
        </div>

        <div className="flex flex-col gap-[6px] w-[50%]">
          <div className="text-[#222B45] text-[14px]">Date of Birth</div>
          <DOB
            displayDob={displayDOB}
            updateDisplayDOB={updateDisplayDOB}
            selectedDob={customerData?.dob}
            componentType="bookingDetails"
            updateDateOfBirth={null}
            handleCustomerDataFieldChange={handleCustomerDataFieldChange}
          />
        </div>
      </div>

      <div className="flex justify-between items-end gap-[24px]">
        <div className="flex flex-col gap-[6px] w-[55%]">
          <div className="text-[#222B45] text-[14px]">Address</div>
          <CustomTextField
            label=""
            value={customerData?.address}
            onChange={(value) =>
              handleCustomerDataFieldChange("address", value)
            }
            isMandatory={false}
            type="text"
            inputPadding={true}
            inputPaddingValue="2px"
            borderColor="#EDF1F7"
            borderWidth="1px"
          />
        </div>

        <div className="flex flex-col gap-[6px] w-[50%]">
          <GenderButton
            gender={customerData?.gender}
            updateGender={(newGender) =>
              handleCustomerDataFieldChange("gender", newGender)
            }
            componentType="bookingDetails"
            width="100%"
            handleCustomerDataFieldChange={handleCustomerDataFieldChange}
          />
        </div>
      </div>

      <UploadId
        id={customerData?.idImages}
        setId={null}
        setData={handleCustomerDataFieldChange}
        componentType="addPrimaryGuestDrawer"
      />
    </div>
  );
};

const CompanyDetails = ({ customerData, handleCustomerDataFieldChange }) => {
  return (
    <div className="mt-3 px-4 flex flex-col gap-[16px] relative no-scrollbar">
      <div className="flex justify-between items-center gap-[24px]">
        <div className="flex flex-col gap-[6px] w-[55%]">
          <div className="text-[#222B45] text-[14px]"> Company Name</div>

          <CustomTextField
            label=""
            isManadatory={false}
            value={customerData?.company}
            onChange={(value) =>
              handleCustomerDataFieldChange("company", value)
            }
            type="text"
            inputPadding={true}
            inputPaddingValue="2px"
            borderColor="#EDF1F7"
            borderWidth="1px"
          />
        </div>

        <div className="flex flex-col gap-[6px] w-[50%]">
          <div className="text-[#222B45] text-[14px]">Designation</div>

          <CustomTextField
            label=""
            isManadatory={false}
            value={customerData?.designation}
            onChange={(value) =>
              handleCustomerDataFieldChange("designation", value)
            }
            type="text"
            inputPadding={true}
            inputPaddingValue="2px"
            borderColor="#EDF1F7"
            borderWidth="1px"
          />
        </div>
      </div>

      <div className="flex flex-col gap-[6px]">
        <div className="text-[#222B45] text-[14px]">Company GSTIN</div>

        <CustomTextField
          label=""
          isManadatory={false}
          value={customerData?.gstIN}
          onChange={(value) => handleCustomerDataFieldChange("gstIN", value)}
          type="text"
          inputPadding={true}
          inputPaddingValue="2px"
          borderColor="#EDF1F7"
          borderWidth="1px"
        />
      </div>
    </div>
  );
};

const ForeignDetails = ({ customerData, handleCustomerDataFieldChange }) => {
  return (
    <div className="mt-3 px-4 flex flex-col gap-[16px] relative no-scrollbar">
      <div className="flex justify-between items-center gap-[24px]">
        <div className="flex flex-col gap-[6px] w-[55%]">
          <div className="text-[#222B45] text-[14px]">Nationality</div>

          <CustomTextField
            label=""
            isManadatory={false}
            value={customerData?.nationality}
            onChange={(value) =>
              handleCustomerDataFieldChange("nationality", value)
            }
            type="text"
            inputPadding={true}
            inputPaddingValue="2px"
            borderColor="#EDF1F7"
            borderWidth="1px"
          />
        </div>

        <div className="flex flex-col gap-[6px] w-[50%]">
          <div className="text-[#222B45] text-[14px]">Passport No</div>

          <CustomTextField
            label=""
            isManadatory={false}
            value={customerData?.passportNumber}
            onChange={(value) =>
              handleCustomerDataFieldChange("passportNumber", value)
            }
            type="text"
            inputPadding={true}
            inputPaddingValue="2px"
            borderColor="#EDF1F7"
            borderWidth="1px"
          />
        </div>
      </div>

      <div className="flex justify-between items-center gap-[24px]">
        <div className="flex flex-col gap-[6px] w-[55%]">
          <div className="text-[#222B45] text-[14px]">Visa No</div>

          <CustomTextField
            label=""
            isManadatory={false}
            value={customerData?.grcDetails?.visaNumber}
            onChange={(value) =>
              handleCustomerDataFieldChange("grcDetails", {
                ...customerData?.grcDetails,
                visaNumber: value,
              })
            }
            type="text"
            inputPadding={true}
            inputPaddingValue="2px"
            borderColor="#EDF1F7"
            borderWidth="1px"
          />
        </div>

        <div className="flex flex-col gap-[6px] w-[50%]">
          <div className="text-[#222B45] text-[14px]">Visa Type</div>

          <CustomTextField
            label=""
            isManadatory={false}
            value={customerData?.grcDetails?.visaType}
            onChange={(value) =>
              handleCustomerDataFieldChange("grcDetails", {
                ...customerData?.grcDetails,
                visaType: value,
              })
            }
            type="text"
            inputPadding={true}
            inputPaddingValue="2px"
            borderColor="#EDF1F7"
            borderWidth="1px"
          />
        </div>
      </div>

      <div>
        <ArrivalAndDurationDate
          customerData={customerData}
          handleCustomerDataFieldChange={handleCustomerDataFieldChange}
        />
      </div>
    </div>
  );
};

const Footer = ({ loading, customerData, handleSave }) => {
  return (
    <div
      style={{ width: bookingDetailsDrawerWidth }}
      className="py-4  border-t-[1px] border-[#EDF1F7] uppercase fixed right-0 bottom-0 flex justify-end w-full px-4"
    >
      {Boolean(loading) ? (
        <Button className="text-white py-2 bg-[#007FFF]" disabled>
          <CircularProgress size={16} color="inherit" />
        </Button>
      ) : (
        <Button className="text-white py-2 bg-[#007FFF]" onClick={handleSave}>
          {Boolean(customerData?.id) ? "Edit" : "Add"} Primary Guest
        </Button>
      )}
    </div>
  );
};

export default AddPrimaryGuestDrawer;
